import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Stack } from "@mui/material";
import copy from "copy-to-clipboard";
import { DETECTION_ICONS } from "../../../../icons/detectionLucideIcons";
import { buildBotEventDrawerSections } from "./botEventDrawerData";
import SmartParseRawJsonViewer from "./v3/SmartParseRawJsonViewer";
import {
  EventAssessGrid,
  SmartParseSectionCard as SectionCard,
} from "./v3/smartParseDrawerUi";

export default function BotEventDrawerBody({ event, onCopy }) {
  const sections = useMemo(() => buildBotEventDrawerSections(event), [event]);

  const handleCopy = (value) => {
    copy(value);
    onCopy?.(value);
  };

  return (
    <Stack spacing={1.75} sx={{ pb: 2 }}>
      {sections.detectionAssessCells.length > 0 ? (
        <SectionCard icon={DETECTION_ICONS.clipboard} title="Assessment">
          <EventAssessGrid cells={sections.detectionAssessCells} onCopy={handleCopy} />
        </SectionCard>
      ) : null}

      {sections.requestAssessCells.length > 0 ? (
        <SectionCard icon={DETECTION_ICONS.request} title="Request Details">
          <EventAssessGrid cells={sections.requestAssessCells} onCopy={handleCopy} />
        </SectionCard>
      ) : null}

      {sections.responseAssessCells.length > 0 ? (
        <SectionCard icon={DETECTION_ICONS.response} title="Response Details">
          <EventAssessGrid cells={sections.responseAssessCells} onCopy={handleCopy} />
        </SectionCard>
      ) : null}

      {sections.networkAssessCells.length > 0 ? (
        <SectionCard icon={DETECTION_ICONS.ipReputation} title="Client & Network">
          <EventAssessGrid cells={sections.networkAssessCells} onCopy={handleCopy} />
        </SectionCard>
      ) : null}

      {sections.tlsAssessCells.length > 0 ? (
        <SectionCard icon={DETECTION_ICONS.ja3} title="TLS & Fingerprints">
          <EventAssessGrid cells={sections.tlsAssessCells} onCopy={handleCopy} />
        </SectionCard>
      ) : null}

      {sections.metadataAssessCells.length > 0 ? (
        <SectionCard icon={DETECTION_ICONS.clipboard} title="Event Metadata">
          <EventAssessGrid cells={sections.metadataAssessCells} onCopy={handleCopy} />
        </SectionCard>
      ) : null}

      <SectionCard
        icon={DETECTION_ICONS.cache}
        title="Raw Event"
        collapsible
        defaultExpanded={false}
      >
        <SmartParseRawJsonViewer data={sections.payload} />
      </SectionCard>
    </Stack>
  );
}

BotEventDrawerBody.propTypes = {
  event: PropTypes.object.isRequired,
  onCopy: PropTypes.func,
};
